export const interactionModes = {
  START: 'ON_START',
  FINISH: 'ON_FINISH'
}
